// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Pt","modify_order":"Qt","modify_order_header":"Rt","product_details_form_wrapper":"St","c_wrapper":"Tt","save_button":"Ut","title":"Vt","modify_order_title_wrapper":"Wt","note":"Xt","buttons_wrapper":"Yt"};
    if(module.hot) {
      // 1714442366340
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  